/* LUMEN 국내몰(카페24 skin35) 디자인 싱크 (2026-10-03, 2026-10-07 국내몰 기준 재동기화, BGROW)
   국내몰 head.html 의 상단 메뉴 패널, SHOP BY LINE / SHOP BY CATEGORY, 분류 줄, 전체 보기, 배열 버튼, 라인 검색 보충을
   이 테마(LUMEN 커스텀 Dawn)의 마크업에 맞춰 옮긴 것. 데이터는 lumen-sync-data.js 와 snippets/lumen-sync.liquid(window.LUMEN_SHOP). */
(function () {
  'use strict';
  var SHOP = window.LUMEN_SHOP || {};
  var ROOT = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function localUrl(path) {
    path = String(path || '');
    if (!path || path.charAt(0) === '#') return path;
    if (/^(?:https?:)?\/\//i.test(path)) {
      try {
        var absolute = new URL(path, location.origin);
        if (absolute.host !== location.host) return path;
        path = absolute.pathname + absolute.search + absolute.hash;
      } catch (e) { return path; }
    } else if (/^[a-z][a-z0-9+.-]*:/i.test(path)) return path;
    var root = String(ROOT || '/').replace(/\/+$/, '');
    if (!root) return path.charAt(0) === '/' ? path : '/' + path;
    if (path === root || path.indexOf(root + '/') === 0) return path;
    return root + '/' + path.replace(/^\/+/, '');
  }
  function unlocalPath(path) {
    path = String(path || '/');
    var root = String(ROOT || '/').replace(/\/+$/, '');
    return root && (path === root || path.indexOf(root + '/') === 0) ? path.slice(root.length) || '/' : path;
  }
  function C(handle, q) { return localUrl('/collections/' + handle + (q ? '?' + q : '')); }
  // 종류/라인 검색. 국내몰처럼 상품명에서만 찾도록 Shopify 검색의 title: 조건을 씀(설명에 단어가 있는 상품은 빠짐).
  // cat 을 주면 그 분류의 SHOP BY CATEGORY 줄이 검색 결과에도 나옴
  function S(q, cat) { return localUrl('/search?q=' + encodeURIComponent('title:' + q) + '&type=product' + (cat ? '&lumen_cat=' + cat : '')); }
  function cleanQ(v) { return String(v || '').trim().toUpperCase().replace(/^TITLE:\s*/, '').replace(/^"|"$/g, ''); }
  var NEW = 'sort_by=created-descending', BEST = 'sort_by=best-selling';

  /* ───────── 1. 상단 메뉴 ───────── */
  // 패널 사진: [주소, 세로 위치]. 국내몰과 같은 사진(브랜드 제공 메뉴 사진은 atlm.kr/web/upload/lumen-menu)
  var M = 'https://atlm.kr/web/upload/lumen-menu/', P = 'https://atlm.kr/web/product/big/';
  var IMG = {
    // 2026-10-06 브랜드 제공 메뉴 사진 (1200x706 = 칸 비율 그대로, 국내몰과 같은 파일)
    bagLine: [M + 'bag-collection-2610.jpg', '50%'], bagCate: [M + 'bag-category-2610.jpg', '50%'],
    bagLtd: [M + 'bag-limited-2610.jpg', '50%'], bagMens: [M + 'bag-mens-2610.jpg', '50%'],
    shoeCate: [M + 'shoes-category-2610.jpg', '50%'], shoeLtd: [M + 'shoes-limited-2610.jpg', '50%'], shoeMens: [M + 'shoes-mens-2610.jpg', '50%'],
    accCate: [M + 'acc-category-2610.jpg', '50%'], accLtd: [M + 'acc-limited-2610.jpg', '50%'], accMens: [M + 'acc-mens-2610.jpg', '50%'],
    story: [M + 'story-2610.jpg', '50%'], info: [M + 'info-2610.jpg', '50%'], member: [M + 'membership-2610.jpg', '50%'], stockist: ['https://atlm.kr/web/upload/stockist-1.jpg', '50%']
  };
  var LINES = window.LUMEN_LINES || [];
  // 라인 링크: 국내몰처럼 라인과 대표 모델을 함께 넘겨 검색 결과를 라인 순서로 정렬 (lineOrder)
  function lineHref(l) { var f = l[2] && l[2][0] ? l[2][0][0] : ''; return S(l[3] || l[0]) + '&lumen_line=' + encodeURIComponent(l[0]) + (f ? '&lumen_first=' + encodeURIComponent(f) : ''); }
  function storyItems() {
    var want = ['PARCO SHIBUYA', 'LUMEN X SAINTE MARIA', 'LUMEN X IHNN', 'NEWOMAN', 'LUMEN X YEODONG YUN'];
    var list = [['ALL STORIES', '/blogs/story']];
    want.forEach(function (w) { var a = (SHOP.stories || []).filter(function (x) { return x.title === w; })[0]; if (a) list.push([a.title === 'NEWOMAN' ? 'NEWoMan' : a.title, a.url]); });
    return list;
  }
  // EARLY BLACK FRIDAY 메뉴 공개 시각 (컬렉션 공개 예약과 동일: 2026-10-26 10:00 KST). 그 전에는 메뉴에서 숨김.
  var EBF_OPEN = Date.now() >= Date.parse('2026-10-26T10:00:00+09:00');
  // ★ 상단 메뉴 (국내몰 LUMEN_NAV 와 같은 구성). fold:true = 모바일 아코디언(첫 구역만 펼침), lines:true = 모바일에서 라인 사진 3열
  var NAV = [
    { label: 'BAG', handle: 'bag', href: C('featured-products'), fold: true, mega: [
      { title: 'COLLECTION', img: IMG.bagLine, all: C('featured-products'), lines: true, items: LINES.map(function (l) { return [l[0], lineHref(l)]; }) },
      { title: 'CATEGORY', img: IMG.bagCate, all: C('featured-products'), items: (EBF_OPEN ? [['EARLY BLACK FRIDAY', C('early-black-friday')]] : []).concat([['NEW', C('featured-products', NEW)], ['BEST SELLER', C('featured-products', BEST)], ['TOTE', C('top-handle-1')], ['SHOULDER', C('top-handle')], ['CROSSBODY', C('crossbody')]]) },
      { title: 'LIMITED EDITION', img: IMG.bagLtd, all: C('collaboration'), items: [['LUMEN X SAINTE MARIA', S('SAINTE MARIA')], ['LUMEN X IHNN', S('IHNN')], ['LUMEN X YUN YEODONG', S('YEODONG')]] },
      { title: 'MENS', img: IMG.bagMens, all: C('mens'), items: [] }
    ] },
    { label: 'SHOES', handle: 'shoes', href: C('shoes'), fold: true, mega: [
      { title: 'CATEGORY', img: IMG.shoeCate, all: C('shoes'), items: [['NEW', C('shoes', NEW)], ['BEST SELLER', C('shoes', BEST)], ['FLAT', S('FLAT', 'shoes')], ['LOAFER', S('LOAFER', 'shoes')], ['DERBY', S('DERBY', 'shoes')], ['FLIP', S('FLIP', 'shoes')], ['MULE', S('MULES', 'shoes')], ['BOOTS', S('BOOTS', 'shoes')]] },
      { title: 'LIMITED EDITION', img: IMG.shoeLtd, all: S('IHNN', 'shoes'), items: [['LUMEN X IHNN', S('IHNN', 'shoes')]] },
      { title: 'MENS', img: IMG.shoeMens, all: S("MEN'S", 'shoes'), items: [] }
    ] },
    { label: 'ACC', handle: 'acc', href: C('acc'), fold: true, mega: [
      { title: 'CATEGORY', img: IMG.accCate, all: C('acc'), items: [['NEW', C('acc', NEW)], ['BEST SELLER', C('acc', BEST)], ['BELT', S('BELT', 'acc')], ['CARD HOLDER', S('CARD', 'acc')], ['WALLET', S('WALLET', 'acc')], ['POUCH', S('POUCH', 'acc')], ['INNER BAG', S('INNER', 'acc')], ['CHARM', S('CHARM', 'acc')], ['GLASSES CASE', S('GLASSES', 'acc')], ['LIP CASE', S('LIP', 'acc')], ['NECKLACE', S('NECKLACE', 'acc')]] },
      { title: 'LIMITED EDITION', img: IMG.accLtd, all: C('collaboration'), items: [['LUMEN X YUN YEODONG', S('YEODONG')], ['LUMEN X SAINTE MARIA', S('SAINTE MARIA')], ['LUMEN X IHNN', S('IHNN', 'acc')]] },
      { title: 'MENS', img: IMG.accMens, all: S("MEN'S", 'acc'), items: [] }
    ] },
    { label: 'COLLECTION', handle: 'collection', href: '/blogs/collection', rail: true },
    { label: 'OUR STORY', handle: 'our-story', href: '/blogs/story', mega: [
      { title: 'STORY', img: IMG.story, all: '/blogs/story', items: storyItems() },
      { title: 'INFO', img: IMG.info, all: '/pages/our-philosophy', items: [['OUR PHILOSOPHY', '/pages/our-philosophy'], ['CARE GUIDE', '/pages/materials'], ['MATERIALS', '/pages/materials']] },
      { title: 'MEMBERSHIP', img: IMG.member, all: '/pages/membership-benefits', items: [['LUMENIER BENEFITS', '/pages/membership-benefits']] },
      { title: 'STOCKIST', img: IMG.stockist, all: '/pages/stockist', items: [['HANNAM FLAGSHIP STORE', '/pages/stockist'], ['SHINSEGAE CENTUM CITY STORE', '/pages/stockist']] }
    ] }
  ];
  var VIEW_ALL = 'VIEW ALL';

  // 라인 사진: 가방이 칸 바닥선에 서도록 LUMEN_BOX(사진 안 상품 범위)와 LUMEN_SCALE(모델별 크기 %)로 위치를 정함.
  // 2026-10-06 국내몰과 같은 편집기 규칙: 가방의 긴 변 = 칸 너비 x 비율 (메뉴 정사각 칸 80%, SHOP BY LINE 95%). 비율이 없는 사진(SHOES, ACC)은 기존처럼 칸에 맞춤
  var BOX_RATIO = 1.25, FIT_W = 0.78, FIT_H = 0.94, MENU_RATIO = 1.0, STRIP_RATIO = BOX_RATIO; // STRIP_RATIO: 지금 그리는 사진 줄의 칸 비율 (BAG 라인 줄 = 정사각 1.0)
  // 모바일 메뉴 BAG 컬렉션 칸은 대표 라인 9개만 (26AW 2ND, 1ST 라인과 MARRON)
  var MENU_LINES = ['DOUBLE', 'FADE', 'CUBE', 'KARRY', 'LOG', 'PANIER', 'BRISE', 'COLLEN', 'MARRON'];
  var SCALE_BY_IMG = {};
  LINES.forEach(function (l) { l[2].forEach(function (m) { var p = (window.LUMEN_SCALE || {})[m[0]]; if (p) SCALE_BY_IMG[key(m[1])] = p / 100; }); });
  function key(u) { return String(u || '').split('/').pop().split('.')[0]; }
  function placeStyle(img, menu) {
    var b = (window.LUMEN_BOX || {})[key(img)]; if (!b) return '';
    var bw = b[2] - b[0], bh = b[3] - b[1], r = b[4]; if (bw <= 0 || bh <= 0) return '';
    var sc = SCALE_BY_IMG[key(img)], ratio = menu ? MENU_RATIO : STRIP_RATIO;
    var k = menu ? 0.80 * (sc || 1) / Math.max(bw, bh * r)
      : sc ? Math.min(sc, 0.96) / Math.max(bw, bh * r) : Math.min(FIT_W / bw, FIT_H * ratio / (bh * r)); // 2026-10-07 국내몰과 같음: 긴 변 = 칸 너비 x 비율(최대 96%)
    return 'width:' + (k * 100).toFixed(1) + '%;left:' + (50 - k * (b[0] + bw / 2) * 100).toFixed(1) + '%;bottom:' + (3 - (1 - b[3]) * k * r / ratio * 100).toFixed(1) + '%';
  }
  function linesHtml() {
    return '<div class="lsm-lines">' + LINES.filter(function (l) { return MENU_LINES.indexOf(String(l[0]).trim().toUpperCase().split(' ')[0]) > -1; }).map(function (l) {
      var st = placeStyle(l[1], true);
      return '<a class="lsm-line" href="' + esc(lineHref(l)) + '"><span class="lsm-line-img"><img src="' + esc(l[1]) + '" alt="" loading="lazy"' + (st ? ' class="is-placed" style="' + st + '"' : '') + '></span><span class="lsm-line-name">' + esc(l[0]) + '</span></a>';
    }).join('') + '</div>';
  }
  function panelHtml(cols) {
    return cols.map(function (c) {
      var all = esc(localUrl(c.all));
      var h = '<div class="lsm-col' + (c.lines ? ' has-lines' : '') + '"><h4>' + esc(c.title) + '</h4><a class="lsm-img" href="' + all + '"><img src="' + esc(c.img[0]) + '" alt="' + esc(c.title) + '" loading="lazy" style="object-position:center ' + esc(c.img[1]) + '"></a>';
      h += '<a class="lsm-all" href="' + all + '">' + VIEW_ALL + '</a><ul>';
      c.items.forEach(function (it) { h += '<li><a href="' + esc(localUrl(it[1])) + '">' + esc(it[0]) + '</a></li>'; });
      return h + '</ul>' + (c.lines ? linesHtml() : '') + '</div>';
    }).join('');
  }
  // COLLECTION 줄: 블로그 "collection" 글 (ALL COLLECTION 이 맨 앞, 그다음 최신 시즌 순)
  function railCards() {
    return (SHOP.collections || []).filter(function (c) { return c.img; }).map(function (c) {
      var href = /^ALL\b/.test(c.title) ? '/blogs/collection' : c.url;
      return '<a class="lr-card" href="' + esc(localUrl(href)) + '" draggable="false"><span class="lr-img"><img data-src="' + esc(c.img) + '" alt="" draggable="false"></span><span class="lr-name">' + esc(c.title) + '</span></a>';
    }).join('');
  }
  var ARROW_NEXT_PATH = 'M0.682527 9.28511L0 8.60258L3.96003 4.64255L0 0.682527L0.682527 0L5.32508 4.64255L0.682527 9.28511Z';
  function makePanel(n) {
    var p = document.createElement('div');
    if (n.mega) { p.className = 'lumen-mega'; p.innerHTML = panelHtml(n.mega); return p; }
    p.className = 'lumen-mega lumen-rail';
    p.innerHTML = '<div class="lr-track">' + railCards() + '</div><button type="button" class="lr-next" aria-label="Next collections"><svg width="8" height="14" viewBox="0 0 6 10" fill="currentColor" aria-hidden="true"><path d="' + ARROW_NEXT_PATH + '"/></svg></button>';
    var tr = p.querySelector('.lr-track'); bindDrag(tr, true);
    p._sync = function () { p.classList.toggle('is-end', tr.scrollLeft >= tr.scrollWidth - tr.clientWidth - 2); };
    tr.addEventListener('scroll', p._sync, { passive: true });
    p.querySelector('.lr-next').addEventListener('click', function () { tr.scrollBy({ left: tr.clientWidth * 0.8, behavior: 'smooth' }); });
    return p;
  }
  // 컬렉션 사진은 패널을 열 때 화면 가까이 온 카드만 불러옴
  function activate(panel) {
    var tr = panel.querySelector('.lr-track'); if (!tr) return;
    if (panel._sync) panel._sync();
    var set = function (im) { if (im.hasAttribute('data-src')) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); } };
    var imgs = tr.querySelectorAll('img[data-src]');
    if (!('IntersectionObserver' in window)) { [].forEach.call(imgs, set); return; }
    var opt = panel.closest('.mobile-nav') ? { rootMargin: '600px 0px' } : { root: tr, rootMargin: '0px 900px' };
    if (!tr._io) tr._io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { tr._io.unobserve(e.target); set(e.target); } }); }, opt);
    [].forEach.call(imgs, function (im) { if (!im._ob) { im._ob = 1; tr._io.observe(im); } });
  }
  // 마우스로 끌어서 가로 이동. wheel=true 면 세로 휠도 가로로. 끌다 놓을 때 생기는 click 은 링크 이동으로 처리하지 않음
  function bindDrag(track, wheel) {
    var down = false, moved = false, sx = 0, sl = 0;
    track.addEventListener('mousedown', function (e) { if (e.button !== 0) return; down = true; moved = false; sx = e.pageX; sl = track.scrollLeft; });
    window.addEventListener('mousemove', function (e) {
      if (!down) return; var dx = e.pageX - sx;
      if (!moved && Math.abs(dx) < 5) return;
      moved = true; track.classList.add('is-dragging'); track.scrollLeft = sl - dx; e.preventDefault();
    });
    window.addEventListener('mouseup', function () { if (!down) return; down = false; track.classList.remove('is-dragging'); });
    track.addEventListener('click', function (e) { if (moved) { moved = false; e.preventDefault(); e.stopPropagation(); } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    if (wheel) track.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      var max = track.scrollWidth - track.clientWidth; if (max <= 0) return;
      var d = e.deltaY * (e.deltaMode === 1 ? 40 : 1);
      if ((d < 0 && track.scrollLeft <= 0) || (d > 0 && track.scrollLeft >= max - 1)) return;
      track.scrollLeft += d; e.preventDefault();
    }, { passive: false });
  }
  // PC: #LumenPCNav 항목을 새 메뉴로 바꾸고, #MegaPanel 안을 메뉴별 패널로 교체.
  // 패널을 열고 닫는 것(nav 에 마우스가 들어오면 열고, nav 와 패널을 벗어나면 닫음)은 테마 헤더 스크립트가 그대로 함
  function buildPc() {
    var nav = document.getElementById('LumenPCNav'), mega = document.getElementById('MegaPanel');
    var ul = nav && nav.querySelector('ul'); if (!ul || !mega || mega.querySelector('.lumen-megas')) return;
    ul.innerHTML = NAV.map(function (n) {
      return '<li><a id="HeaderMenu-' + n.handle + '" href="' + esc(localUrl(n.href)) + '" class="header__menu-item list-menu__item link link--text focus-inset" data-menu-handle="lumen-' + n.handle + '"><span>' + esc(n.label) + '</span></a></li>';
    }).join('');
    var box = document.createElement('div'); box.className = 'lumen-megas';
    var inner = mega.querySelector('.mega-panel__inner'); if (inner) inner.style.display = 'none';
    mega.appendChild(box); mega.classList.add('lumen-synced');
    var items = [].slice.call(ul.querySelectorAll('a[data-menu-handle]'));
    var panels = NAV.map(function (n) { var p = makePanel(n); box.appendChild(p); return p; });
    var show = function (i) {
      panels.forEach(function (p, j) { p.classList.toggle('is-open', j === i); });
      items.forEach(function (a, j) { a.classList.toggle('is-active', j === i); });
      activate(panels[i]);
    };
    items.forEach(function (a, i) { a.addEventListener('mouseenter', function () { show(i); }); a.addEventListener('focus', function () { show(i); }); });
    nav.addEventListener('mouseenter', function () { if (!panels.some(function (p) { return p.classList.contains('is-open'); })) show(0); });
    nav.classList.add('lumen-ready'); // 새 메뉴가 준비되면 보임 (그전에는 snippet 의 스타일로 숨김: 원래 메뉴가 잠깐 보이는 깜빡임 방지)
    // 레일을 끌다가 패널 밖으로 나가도 닫히지 않게: 끄는 동안 패널을 벗어나는 이벤트를 테마 스크립트까지 보내지 않음
    mega.addEventListener('mouseleave', function (e) { if (mega.querySelector('.lr-track.is-dragging')) e.stopImmediatePropagation(); }, true);
  }
  // 모바일: #MobileNavTabs 탭과 #MobileNavPanels 패널을 새 메뉴로 교체 (국내몰 모바일 메뉴와 같은 1열 + 아코디언)
  function accordion(panel) {
    panel.classList.add('is-fold');
    [].forEach.call(panel.querySelectorAll('.lsm-col'), function (col, i) {
      var h = col.querySelector('h4'); if (!h) return;
      h.insertAdjacentHTML('beforeend', '<span class="lsm-pm" aria-hidden="true"></span>');
      h.setAttribute('role', 'button'); h.setAttribute('tabindex', '0');
      var set = function (open) { col.classList.toggle('is-closed', !open); h.setAttribute('aria-expanded', open ? 'true' : 'false'); };
      var flip = function () { set(col.classList.contains('is-closed')); };
      set(i === 0);
      h.addEventListener('click', flip);
      h.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); } });
    });
  }
  function buildMobile() {
    var tabs = document.getElementById('MobileNavTabs'), wrap = document.getElementById('MobileNavPanels');
    if (!tabs || !wrap || wrap.querySelector('.lumen-mega')) return;
    tabs.innerHTML = NAV.map(function (n, i) {
      return '<button class="mobile-nav__tab' + (i === 0 ? ' is-active' : '') + '" role="tab" aria-selected="' + (i === 0) + '" aria-controls="MobilePanel-lumen-' + n.handle + '" data-handle="lumen-' + n.handle + '" id="MobileTab-lumen-' + n.handle + '" type="button">' + esc(n.label) + '</button>';
    }).join('');
    wrap.innerHTML = '';
    var panes = NAV.map(function (n, i) {
      var pane = document.createElement('div');
      pane.className = 'mobile-nav__panel lumen-m-pane' + (i === 0 ? ' is-active' : '');
      pane.id = 'MobilePanel-lumen-' + n.handle; pane.setAttribute('role', 'tabpanel');
      var p = makePanel(n); p.classList.add('is-open'); pane.appendChild(p);
      if (n.mega && n.fold) accordion(p);
      wrap.appendChild(pane);
      return pane;
    });
    var btns = [].slice.call(tabs.querySelectorAll('.mobile-nav__tab'));
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        btns.forEach(function (x, j) { x.classList.toggle('is-active', j === i); x.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        panes.forEach(function (x, j) { x.classList.toggle('is-active', j === i); });
        activate(panes[i].querySelector('.lumen-mega'));
        var s = document.getElementById('MobileSearchPanel'); if (s) s.classList.remove('is-active');
        wrap.scrollTop = 0;
      });
    });
    tabs.classList.add('lumen-ready'); wrap.classList.add('lumen-ready');
    var navEl = document.getElementById('MobileMegaNav');
    if (navEl && window.MutationObserver) new MutationObserver(function () { if (navEl.classList.contains('is-open')) { var a = wrap.querySelector('.mobile-nav__panel.is-active .lumen-mega'); if (a) activate(a); } }).observe(navEl, { attributes: true, attributeFilter: ['class'] });
  }

  /* ───────── 2. 컬렉션 / 검색 목록 ───────── */
  var params = new URLSearchParams(location.search);
  var path = unlocalPath(location.pathname);
  var collMatch = /^\/collections\/([^\/?#]+)/.exec(path), coll = collMatch ? collMatch[1] : '';
  var isSearch = /^\/search\b/.test(path);
  var q = cleanQ(params.get('q'));
  var BAG_COLLS = ['featured-products', 'top-handle-1', 'top-handle', 'crossbody'];
  var lineOfQuery = LINES.filter(function (l) { return q && q === String(l[3] || l[0]).toUpperCase(); })[0];
  var cat = isSearch ? (params.get('lumen_cat') || '') : (coll === 'shoes' || coll === 'acc' ? coll : '');

  // 분류 줄: BAG 은 NEW, BEST SELLER, TOP HANDLE, SHOULDER, CROSSBODY / SHOES, ACC 는 NEW, BEST SELLER
  function cateRow() {
    var base = BAG_COLLS.indexOf(coll) > -1 ? 'featured-products' : (coll === 'shoes' || coll === 'acc') ? coll : '';
    if (!base || document.querySelector('.lumen-cate-row')) return null;
    var items = [['NEW', C(base, NEW)], ['BEST SELLER', C(base, BEST)]];
    if (base === 'featured-products') items = items.concat([['TOP HANDLE', C('top-handle-1')], ['SHOULDER', C('top-handle')], ['CROSSBODY', C('crossbody')]]);
    var sort = params.get('sort_by') || '';
    var row = document.createElement('ul'); row.className = 'lumen-cate-row';
    row.innerHTML = items.map(function (it) {
      var u = new URL(it[1], location.origin), itemPath = unlocalPath(u.pathname), on = itemPath === path && (u.searchParams.get('sort_by') || '') === sort && (!!sort || itemPath !== '/collections/' + base);
      return '<li><a href="' + esc(it[1]) + '"' + (on ? ' class="is-current" aria-current="page"' : '') + '>' + esc(it[0]) + '</a></li>';
    }).join('');
    return row;
  }
  // 전체 보기 대상: 하위 분류, 정렬 페이지, 검색 결과. 분류 첫 화면은 없음
  function viewAllTarget() {
    if (isSearch) return cat === 'shoes' ? C('shoes') : cat === 'acc' ? C('acc') : lineOfQuery ? C('featured-products') : C('all');
    if (['top-handle-1', 'top-handle', 'crossbody'].indexOf(coll) > -1) return C('featured-products');
    if ((BAG_COLLS.indexOf(coll) > -1 || coll === 'shoes' || coll === 'acc') && params.get('sort_by')) return C(coll === 'shoes' || coll === 'acc' ? coll : 'featured-products');
    return null;
  }

  // SHOP BY LINE (BAG) / SHOP BY CATEGORY (SHOES, ACC): 국내몰 목록 상단 사진 줄과 같은 동작
  var GAP = 8, STEP = 4;
  var ARROW_PREV = '<svg width="7" height="12" viewBox="0 0 6 10" fill="none" aria-hidden="true"><path d="M4.64255 5.04851e-05L5.32507 0.682577L1.36505 4.6426L5.32507 8.60263L4.64255 9.28516L-6.26986e-06 4.6426L4.64255 5.04851e-05Z"/></svg>';
  var ARROW_NEXT = '<svg width="7" height="12" viewBox="0 0 6 10" fill="none" aria-hidden="true"><path d="' + ARROW_NEXT_PATH + '"/></svg>';
  var ARROW_THIN = '<svg width="7" height="12" viewBox="0 0 6 10" fill="none" aria-hidden="true"><path d="M0.4 0.4L4.64 4.64L0.4 8.88"/></svg>';
  function stripSet() {
    if (BAG_COLLS.indexOf(coll) > -1 || (isSearch && lineOfQuery)) return { title: 'SHOP BY LINE', items: LINES.map(function (l) { return [l[0], l[1], l[2], lineHref(l)]; }) };
    var T = (window.LUMEN_TYPES || {})[cat];
    return T && T.length ? { title: 'SHOP BY CATEGORY', items: T } : null;
  }
  function card(name, img, href, attrs, lazy) {
    var st = placeStyle(img);
    return '<a class="ll-card"' + (attrs || '') + ' href="' + esc(localUrl(href)) + '" draggable="false"><span class="ll-img"><img ' + (lazy ? 'data-src' : 'src') + '="' + esc(img) + '" alt=""' + (lazy ? '' : ' loading="lazy"') + ' draggable="false"' + (st ? ' class="is-placed" style="' + st + '"' : '') + '></span><span class="ll-name">' + esc(name) + '</span></a>';
  }
  function buildStrip(anchor) {
    var SET = stripSet(); if (!SET || document.querySelector('.lumen-lines')) return null;
    var isLine = SET.title === 'SHOP BY LINE';
    STRIP_RATIO = isLine ? 1.0 : BOX_RATIO;
    var strip = '', map = '';
    SET.items.forEach(function (L) {
      var k = cleanQ(new URL(L[3], location.origin).searchParams.get('q'));
      var cur = isSearch && q && k === q;
      strip += card(L[0], L[1], L[3], (cur ? ' aria-current="page"' : '') + ' data-line="' + esc(L[0]) + '" data-model="' + esc(L[2][0] ? L[2][0][0] : L[0]) + '"').replace('class="ll-card"', 'class="ll-card' + (cur ? ' is-current' : '') + '"');
      map += '<div class="ll-col">' + L[2].slice(1).map(function (m) { return card(m[0], m[1], '/products/' + m[2], '', true); }).join('') + '</div>';
    });
    var box = document.createElement('section'); box.className = 'lumen-lines' + (isLine ? ' is-line' : ''); // is-line: BAG 라인 줄 (정사각 칸, 모바일 3칸)
    box.innerHTML = '<div class="ll-head"><div class="ll-title"><h3>' + SET.title + '</h3></div><div class="ll-nav"><button type="button" class="ll-prev" aria-label="Previous">' + ARROW_PREV + '</button><button type="button" class="ll-next" aria-label="Next">' + ARROW_NEXT + '</button></div></div>'
      + '<div class="ll-scroll"><div class="ll-strip">' + strip + '</div><div class="ll-map">' + map + '</div></div>'
      + '<div class="ll-toggle"><button type="button" aria-expanded="false">' + ARROW_THIN + '<span>ALL STYLES</span></button></div>';
    anchor.parentNode.insertBefore(box, anchor);
    var sc = box.querySelector('.ll-scroll'), first = box.querySelector('.ll-strip .ll-card'), prev = box.querySelector('.ll-prev'), next = box.querySelector('.ll-next');
    var mapEl = box.querySelector('.ll-map'), cols = [].slice.call(mapEl.children), raf = 0;
    // 펼침 목록 높이 = 전체 열 중 가장 긴 열 (2026-10-06, 국내몰과 같음). 넘길 때 높이가 바뀌어 화면이 출렁이지 않게 고정
    var fitMap = function () {
      if (!box.classList.contains('is-open')) return;
      var h = 0;
      cols.forEach(function (c) { h = Math.max(h, c.offsetHeight); });
      if (mapEl.style.height !== h + 'px') mapEl.style.height = h + 'px';
    };
    // 펼칠 때 펼침 목록 사진을 바로 불러옴 (가로 스크롤 칸 안의 지연 로딩은 끝쪽 열을 불러오지 않는 경우가 있어서)
    var eager = function () { [].forEach.call(mapEl.querySelectorAll('img[data-src]'), function (im) { im.setAttribute('loading', 'eager'); im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); im.addEventListener('load', fitMap, { once: true }); }); };
    var names = function (open) { [].forEach.call(box.querySelectorAll('.ll-strip .ll-card'), function (c) { var n = c.querySelector('.ll-name'); if (n) n.textContent = c.getAttribute(open ? 'data-model' : 'data-line'); }); };
    var btn = box.querySelector('.ll-toggle button');
    btn.addEventListener('click', function () {
      var o = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', o ? 'true' : 'false'); btn.querySelector('span').textContent = o ? 'CLOSE' : 'ALL STYLES';
      if (o) eager(); names(o); fitMap();
    });
    // 항목이 한 화면 칸 수보다 적으면 화살표를 숨기고 PC 에서는 간격을 넓혀 줄을 채움
    var few = function () { var w = first.getBoundingClientRect().width; box.classList.toggle('is-few', w > 0 && SET.items.length * (w + GAP) - GAP <= sc.clientWidth + 1); };
    var sync = function () { few(); prev.disabled = sc.scrollLeft <= 1; next.disabled = sc.scrollLeft >= sc.scrollWidth - sc.clientWidth - 1; };
    var perStep = function () { return isLine && window.matchMedia && window.matchMedia('(max-width:1024px)').matches ? 3 : STEP; };
    var step = function (dir) { sc.scrollBy({ left: dir * perStep() * (first.getBoundingClientRect().width + GAP), behavior: 'smooth' }); };
    prev.addEventListener('click', function () { step(-1); }); next.addEventListener('click', function () { step(1); });
    var onMove = function () { sync(); if (!raf) raf = requestAnimationFrame(function () { raf = 0; fitMap(); }); };
    sc.addEventListener('scroll', onMove, { passive: true }); window.addEventListener('resize', onMove); sync();
    var curEl = box.querySelector('.ll-strip .ll-card.is-current');
    if (curEl) { var off = curEl.getBoundingClientRect().left - sc.getBoundingClientRect().left; if (off < 0 || off + curEl.offsetWidth > sc.clientWidth) sc.scrollLeft += off - (first.getBoundingClientRect().width + GAP) * perStep() / 2; }
    bindDrag(sc, false);
    return box;
  }

  // 배열 버튼: PC 한 줄 4 / 8개, 모바일 2 / 4개. 촘촘한 배열(PC 8, 모바일 4)은 사진과 가격만. 고른 값은 브라우저에 기억
  var COLS = { pc: [4, 8], m: [2, 4] }, COLS_KEY = 'lumenListCols';
  function colsLoad() { try { return JSON.parse(localStorage.getItem(COLS_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function colsSave(o) { try { localStorage.setItem(COLS_KEY, JSON.stringify(o)); } catch (e) {} }
  function buildCols() {
    var grid = document.getElementById('product-grid'); if (!grid) return;
    var groups = { pc: document.querySelector('.lumen-view-toggle--desktop'), m: document.querySelector('.lumen-view-toggle--mobile') };
    if (!groups.pc && !groups.m) return; // 배열 버튼이 없는 페이지(검색 결과 등)는 그대로
    var apply = function () {
      var o = colsLoad(), pc = COLS.pc.indexOf(+o.pc) > -1 ? +o.pc : 4, m = COLS.m.indexOf(+o.m) > -1 ? +o.m : 2;
      grid.className = grid.className.replace(/grid--\d+-col-desktop/g, 'grid--4-col-desktop').replace(/grid--\d+-col-tablet-down/g, 'grid--2-col-tablet-down');
      grid.classList.toggle('lumen-cols-pc-8', pc === 8); grid.classList.toggle('lumen-cols-m-4', m === 4);
      Object.keys(groups).forEach(function (g) { if (!groups[g]) return; [].forEach.call(groups[g].querySelectorAll('button'), function (b) { var on = +b.getAttribute('data-cols') === (g === 'pc' ? pc : m); b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); }); });
    };
    Object.keys(groups).forEach(function (g) {
      var el = groups[g]; if (!el || el.getAttribute('data-lumen')) return;
      el.setAttribute('data-lumen', '1'); el.classList.add('lumen-order');
      // 기존 버튼(2/4, 1/2)을 새 버튼으로 바꿈. 칸 4개 중 채운 칸 수(2, 4)로 촘촘함을 표시
      el.innerHTML = COLS[g].map(function (n, i) {
        var cells = ''; for (var k = 0; k < 4; k++) cells += '<span' + (k < (i ? 4 : 2) ? ' class="on"' : '') + '></span>';
        return '<button class="lumen-col-btn lo-btn" data-cols="' + n + '" type="button" aria-label="' + n + ' per row">' + cells + '</button>';
      }).join('');
      [].forEach.call(el.querySelectorAll('button'), function (b) { b.addEventListener('click', function () { var o = colsLoad(); o[g] = +b.getAttribute('data-cols'); colsSave(o); apply(); }); });
    });
    apply();
  }

  // 라인 검색 보충: 라인 검색 결과에, 이름에 라인명이 없는 같은 라인 모델(예: COLLEN 의 MOON BAG, NOTE BUCKLE BAG)을 이어 붙임.
  // 각 모델을 같은 검색 섹션으로 다시 그려 받아(섹션 렌더링) 카드 마크업을 그대로 씀
  function lineSupplement() {
    var none = Promise.resolve();
    if (!isSearch || !lineOfQuery || params.get('page') && params.get('page') !== '1') return none;
    var grid = document.getElementById('product-grid'); if (!grid) return none;
    var sid = grid.getAttribute('data-id'); if (!sid) return none;
    var kw = q, extra = lineOfQuery[2].map(function (m) { return m[0]; }).filter(function (n) { return n.toUpperCase().indexOf(kw) === -1; });
    if (!extra.length) return none;
    var have = {};
    [].forEach.call(grid.querySelectorAll('a[href*="/products/"]'), function (a) { have[a.getAttribute('href').split('?')[0]] = 1; });
    var modelOf = function (li) { var a = li.querySelector('.card__heading a'); return a ? a.textContent.replace(/\s+/g, ' ').replace(/\s*\([^()]*\)\s*$/, '').trim().toUpperCase() : ''; };
    return Promise.all(extra.map(function (name) {
      return fetch(localUrl('/search?q=' + encodeURIComponent('title:' + name) + '&type=product&section_id=' + encodeURIComponent(sid)), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var d = document.createElement('div'); d.innerHTML = html;
          return [].filter.call(d.querySelectorAll('#product-grid > li'), function (li) {
            var a = li.querySelector('a[href*="/products/"]'); var h = a && a.getAttribute('href').split('?')[0];
            if (!h || have[h] || modelOf(li) !== name.toUpperCase()) return false;
            have[h] = 1; return true;
          });
        }).catch(function () { return []; });
    })).then(function (groups) {
      groups.forEach(function (lis) { lis.forEach(function (li) { li.classList.add('lumen-line-extra'); [].forEach.call(li.querySelectorAll('.scroll-trigger'), function (x) { x.classList.remove('scroll-trigger'); }); li.classList.remove('scroll-trigger'); grid.appendChild(li); }); });
    });
  }

  /* ───────── 라인 목록 순서, 할인상품, 정렬 메뉴 (국내몰 2026-10-06 "라인 목록 정렬", "정렬 보강"과 같음) ───────── */
  var AI_URL = 'https://rclqabeeobeghhayiz3abcnsny0ivrjs.lambda-url.ap-northeast-2.on.aws/';
  var lineParam = cleanQ(params.get('lumen_line')), saleOn = params.get('lumen_sale') === '1', clientSort = isSearch ? (params.get('lumen_sort') || '') : '';
  var ALIAS = { 'PANIER DOUX PETIT BAG': 'PANIER DOUX TOTE BAG', 'PANIER DOUX GRAND BAG': 'PANIER DOUX TOTE BAG' };
  function modelName(t) { t = String(t || '').replace(/\s+/g, ' ').replace(/^\s*\[[^\]]*\]\s*/, '').replace(/\s*\([^)]*\)\s*$/, '').trim().toUpperCase(); return ALIAS[t] || t; }
  function cardTitle(li) { var a = li.querySelector('.card__heading a') || li.querySelector('.card__heading'); return a ? a.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function handleOf(li) { var a = li.querySelector('a[href*="/products/"]'); var m = a && /\/products\/([^/?#]+)/.exec(a.getAttribute('href')); return m ? m[1] : ''; }
  function gridItems(grid) { return [].filter.call(grid.children, function (li) { return li.tagName === 'LI'; }); }
  function shown(li) { return li.style.display !== 'none'; }
  function plainCard(li) { [].forEach.call(li.querySelectorAll('.scroll-trigger'), function (x) { x.classList.remove('scroll-trigger'); }); li.classList.remove('scroll-trigger'); return li; }
  // 나머지 페이지 상품을 같은 섹션으로 받아 이어 붙이고 페이지 번호는 숨김. 라인 목록은 국내몰처럼 한 화면에 전부, 할인상품은 모든 페이지에서 모음 (최대 20쪽)
  function loadPages(grid) {
    var sid = grid.getAttribute('data-id'), max = 1, cur = +(params.get('page') || 1);
    [].forEach.call(document.querySelectorAll('a[href*="page="]'), function (a) { var m = /[?&]page=(\d+)/.exec(a.getAttribute('href')); if (m && a.closest('.pagination, .ls-pagination, .pagination-wrapper, nav')) max = Math.max(max, +m[1]); });
    if (!sid || max <= 1) return Promise.resolve();
    var have = {}; gridItems(grid).forEach(function (li) { var h = handleOf(li); if (h) have[h] = 1; });
    var pages = []; for (var p = 1; p <= Math.min(max, 20); p++) if (p !== cur) pages.push(p);
    return Promise.all(pages.map(function (p) {
      var u = new URL(location.href); ['lumen_sale', 'lumen_sort', 'lumen_line', 'lumen_first'].forEach(function (k) { u.searchParams.delete(k); });
      u.searchParams.set('page', p); u.searchParams.set('section_id', sid);
      return fetch(u.pathname + u.search, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        return [].filter.call(d.querySelectorAll('#product-grid > li'), function (li) { var h = handleOf(li); if (!h || have[h]) return false; have[h] = 1; return true; });
      }).catch(function () { return []; });
    })).then(function (groups) {
      groups.forEach(function (lis) { lis.forEach(function (li) { grid.appendChild(plainCard(li)); }); });
      [].forEach.call(document.querySelectorAll('.pagination-wrapper, .ls-pagination, nav.pagination'), function (n) { n.style.display = 'none'; });
    });
  }
  // 라인 목록 순서: [누른 모델 전 컬러] -> [같은 라인 신상 모델(사진 2026-08 이후)] -> [나머지 모델(SHOP BY LINE 순서)] -> [라인 이너백]. 라인 밖 상품은 숨김.
  // 정렬을 직접 고르면(sort_by, lumen_sort, 할인상품) 라인 순서로 다시 섞지 않음
  function lineOrder(grid) {
    if (!isSearch || !lineParam) return;
    var L = LINES.filter(function (l) { return String(l[0]).trim().toUpperCase() === lineParam; })[0]; if (!L) return;
    var firstM = cleanQ(params.get('lumen_first')), models = L[2].map(function (m) { return String(m[0]).trim().toUpperCase(); });
    var order = []; if (models.indexOf(firstM) > -1) order.push(firstM);
    L[2].forEach(function (m, i) { if (/\/2026(0[89]|1[0-2])\//.test(m[1]) && order.indexOf(models[i]) < 0) order.push(models[i]); });
    models.forEach(function (m) { if (order.indexOf(m) < 0) order.push(m); });
    var key = String(L[3] || L[0]).trim().toUpperCase(), word = String(L[0]).trim().toUpperCase(), keep = [];
    gridItems(grid).forEach(function (li, i) {
      var mm = modelName(cardTitle(li)), g = order.indexOf(mm);
      if (g < 0 && /INNER BAG$/.test(mm) && (mm.indexOf(word) === 0 || mm.indexOf(key) === 0)) g = order.length;
      if (g < 0) li.style.display = 'none'; else keep.push({ li: li, g: g, i: i });
    });
    if (!params.get('sort_by') && !clientSort && !saleOn) keep.sort(function (a, b) { return a.g - b.g || a.i - b.i; }).forEach(function (x) { grid.appendChild(x.li); });
  }
  // 할인상품: 정가보다 싸게 파는 상품(카드의 price--on-sale)만
  function saleOnly(grid) {
    if (!saleOn) return;
    gridItems(grid).forEach(function (li) { if (!li.querySelector('.price--on-sale')) li.style.display = 'none'; });
    if (!gridItems(grid).some(shown) && !document.querySelector('.lumen-sale-empty')) grid.insertAdjacentHTML('afterend', '<p class="lumen-sale-empty">No products are on sale right now.</p>');
  }
  // 검색 결과의 신상품순 / 인기순 / 이름순: 쇼피파이 검색은 가격순만 정렬해서 화면에서 정렬. 순위는 AI 서버가 그날 카탈로그에서 내려줌 (op: ranks, 1시간 보관)
  function loadRanks() {
    try { var c = JSON.parse(sessionStorage.getItem('lumenRanks') || 'null'); if (c && Date.now() - c.t < 3600000) return Promise.resolve(c.r); } catch (e) {}
    return fetch(AI_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ op: 'ranks' }) })
      .then(function (r) { return r.json(); }).then(function (d) { var r = d && d.ok ? d.ranks : {}; try { sessionStorage.setItem('lumenRanks', JSON.stringify({ t: Date.now(), r: r })); } catch (e) {} return r; })
      .catch(function () { return {}; });
  }
  function sortOnPage(grid) {
    if (!clientSort) return Promise.resolve();
    var items = gridItems(grid).map(function (li, i) { return { li: li, i: i }; });
    if (clientSort === 'title-ascending') {
      items.forEach(function (x) { x.k = cardTitle(x.li).toUpperCase(); });
      items.sort(function (a, b) { return a.k < b.k ? -1 : a.k > b.k ? 1 : a.i - b.i; }).forEach(function (x) { grid.appendChild(x.li); });
      return Promise.resolve();
    }
    var idx = clientSort === 'created-descending' ? 0 : 1;
    return loadRanks().then(function (R) {
      items.forEach(function (x) { x.k = (R[handleOf(x.li)] || [9999, 9999])[idx]; });
      items.sort(function (a, b) { return a.k - b.k || a.i - b.i; }).forEach(function (x) { grid.appendChild(x.li); });
    });
  }
  function listFlow() {
    var grid = document.getElementById('product-grid'); if (!grid || grid.tagName !== 'UL') return;
    var all = (isSearch && lineParam) || saleOn;
    (all ? loadPages(grid) : Promise.resolve())
      .then(function () { return lineSupplement(); })
      .then(function () { lineOrder(grid); saleOnly(grid); return sortOnPage(grid); });
  }

  // 정렬 메뉴: 국내몰과 같은 순서 (신상품순, 상품명순, 가격 낮은 순, 가격 높은 순, 인기순, 할인상품). 검색 결과는 관련도가 맨 앞, 라인 목록에서는 관련도 숨김.
  // 테마의 PC 정렬 줄(.lumen-sort-options)과 모바일 정렬 창(#LumenSortDrawer)의 버튼을 이 목록으로 바꾸고, 검색 결과에는 같은 모양의 줄과 창을 새로 넣음
  var SORTS = [['created-descending', 'Date, new to old'], ['title-ascending', 'Alphabetically, A-Z'], ['price-ascending', 'Price, low to high'], ['price-descending', 'Price, high to low'], ['best-selling', 'Best selling'], ['sale', 'On sale']];
  var SEARCH_NATIVE = ['relevance', 'price-ascending', 'price-descending'];
  function sortChoices() { var l = SORTS.slice(); if (isSearch && !lineParam) l.unshift(['relevance', 'Relevance']); return l; }
  function sortCurrent() { if (saleOn) return 'sale'; if (isSearch) return clientSort || params.get('sort_by') || (lineParam ? '' : 'relevance'); return params.get('sort_by') || ''; }
  function sortHref(v) {
    var u = new URL(location.href); ['page', 'lumen_sale', 'lumen_sort', 'sort_by'].forEach(function (k) { u.searchParams.delete(k); });
    if (v === 'sale') u.searchParams.set('lumen_sale', '1');
    else if (isSearch && SEARCH_NATIVE.indexOf(v) < 0) u.searchParams.set('lumen_sort', v);
    else u.searchParams.set('sort_by', v);
    return u.pathname + u.search;
  }
  function sortButtons(cls) { var cur = sortCurrent(); return sortChoices().map(function (o) { return '<button type="button" class="' + cls + (o[0] === cur ? ' is-active' : '') + '" data-lumen-sort="' + o[0] + '">' + esc(o[1]) + '</button>'; }).join(''); }
  function buildSort() {
    if (!coll && !isSearch) return;
    var pc = document.querySelector('.lumen-sort-options'), body = document.querySelector('.lumen-sort-drawer__body');
    if (!pc && isSearch && document.getElementById('product-grid') && !document.querySelector('.lumen-search-sort')) {
      var anchor = document.querySelector('.lumen-lines') || document.getElementById('ProductGridContainer');
      var crumb = lineParam ? '<span>SHOP</span><span class="lumen-facets-breadcrumb__sep">&nbsp;&gt;&nbsp;</span><span>BAG</span><span class="lumen-facets-breadcrumb__sep">&nbsp;&gt;&nbsp;</span><span>' + esc(lineParam) + '</span>' : '<span>SEARCH</span>';
      var bar = document.createElement('div'); bar.className = 'lumen-facets-bar lumen-search-sort';
      bar.innerHTML = '<nav class="lumen-facets-breadcrumb" aria-label="breadcrumb">' + crumb + '</nav><div class="lumen-facets-controls"><div class="lumen-sort-options" role="group" aria-label="Sort by"></div><button class="lumen-sort-toggle-btn" type="button">SORT +</button></div>';
      anchor.parentNode.insertBefore(bar, anchor);
      var dr = document.createElement('div'); dr.className = 'lumen-sort-drawer lumen-search-sort-drawer'; dr.setAttribute('aria-hidden', 'true');
      dr.innerHTML = '<div class="lumen-sort-drawer__overlay"></div><div class="lumen-sort-drawer__panel"><div class="lumen-sort-drawer__header"><span>SORT</span><button class="lumen-sort-drawer__close" type="button" aria-label="Close">&#10005;</button></div><div class="lumen-sort-drawer__body"></div></div>';
      document.body.appendChild(dr);
      var openDr = function (o) { dr.classList.toggle('is-open', o); dr.setAttribute('aria-hidden', o ? 'false' : 'true'); document.body.style.overflow = o ? 'hidden' : ''; };
      bar.querySelector('.lumen-sort-toggle-btn').addEventListener('click', function () { openDr(true); });
      dr.querySelector('.lumen-sort-drawer__overlay').addEventListener('click', function () { openDr(false); });
      dr.querySelector('.lumen-sort-drawer__close').addEventListener('click', function () { openDr(false); });
      pc = bar.querySelector('.lumen-sort-options'); body = dr.querySelector('.lumen-sort-drawer__body');
    }
    if (pc) pc.innerHTML = sortButtons('lumen-sort-btn');
    if (body) body.innerHTML = sortButtons('lumen-sort-drawer__option');
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lumen-sort]'); if (!b) return;
    e.preventDefault(); e.stopPropagation(); location.href = sortHref(b.getAttribute('data-lumen-sort'));
  }, true);

  function buildList() {
    // 검색창에는 title: 조건 없이 단어만 보여 줌
    if (isSearch && /^title:/i.test(params.get('q') || '')) [].forEach.call(document.querySelectorAll('input[name="q"]'), function (i) { if (/^title:/i.test(i.value)) i.value = i.value.replace(/^title:\s*/i, ''); });
    var anchor = document.getElementById('ProductGridContainer'); if (!anchor) return;
    var row = cateRow();
    var strip = buildStrip(anchor);
    if (row) anchor.parentNode.insertBefore(row, strip || anchor);
    var target = viewAllTarget();
    if (target && !document.querySelector('.lumen-viewall')) {
      var t = strip && strip.querySelector('.ll-title');
      if (t) t.insertAdjacentHTML('beforeend', '<a class="lumen-viewall ll-all" href="' + esc(target) + '">' + VIEW_ALL + '</a>');
      else { var bar = document.createElement('div'); bar.className = 'lumen-viewall'; bar.innerHTML = '<a href="' + esc(target) + '">' + VIEW_ALL + '</a>'; anchor.parentNode.insertBefore(bar, anchor); }
    }
    buildCols();
    buildSort();
    listFlow();
  }


  /* ───────── 3. 상세 페이지 컬러 ───────── */
  // 모바일에서도 색 칩 대신 상품 사진(CSS), COLOR 라벨 아래 VIEW ALL → 전체 컬러를 큰 사진으로 보는 레이어 (국내몰 상세와 같음)
  function colorName(full) { var m = /\(([^()]+)\)\s*$/.exec(full || ''); return (m ? m[1] : (full || '')).trim(); }
  var layer = null, opener = null;
  function closeLayer() {
    if (!layer || !layer.classList.contains('is-open')) return;
    layer.classList.remove('is-open'); document.documentElement.classList.remove('lumen-lock');
    if (opener) opener.focus();
  }
  function openLayer(box, btn) {
    if (!layer) {
      layer = document.createElement('div'); layer.className = 'lumen-color-layer';
      layer.innerHTML = '<div class="lcl-dim"></div><div class="lcl-panel" role="dialog" aria-modal="true" aria-label="Colors"><div class="lcl-head"><h2>COLOR</h2><button type="button" class="lcl-close" aria-label="Close"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M1 1l14 14M15 1L1 15" stroke="currentColor" stroke-width="1"/></svg></button></div><div class="lcl-grid"></div></div>';
      document.body.appendChild(layer);
      layer.querySelector('.lcl-dim').addEventListener('click', closeLayer);
      layer.querySelector('.lcl-close').addEventListener('click', closeLayer);
      layer.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('.lcl-item.is-current'); if (a) { e.preventDefault(); closeLayer(); } });
      layer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeLayer(); return; }
        if (e.key !== 'Tab') return;
        var f = layer.querySelectorAll('button,a[href]'); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
    layer.querySelector('.lcl-grid').innerHTML = [].map.call(box.querySelectorAll('.product-color-card'), function (c) {
      var im = c.querySelector('.product-color-card__thumb'); if (!im) return '';
      var cur = c.classList.contains('product-color-card--active'), href = c.getAttribute('href') || '#';
      var src = (im.currentSrc || im.src).replace(/([?&])width=\d+/, '$1width=600');
      return '<a class="lcl-item' + (cur ? ' is-current" aria-current="true' : '') + '" href="' + esc(href) + '"><span class="lcl-img"><img src="' + esc(src) + '" alt="" loading="lazy"></span><span class="lcl-name">' + esc(colorName(im.alt)) + '</span></a>';
    }).join('');
    opener = btn; layer.classList.add('is-open'); document.documentElement.classList.add('lumen-lock');
    layer.querySelector('.lcl-panel').scrollTop = 0; layer.querySelector('.lcl-close').focus();
  }
  function buildColors() {
    [].forEach.call(document.querySelectorAll('.product-color-options'), function (box) {
      if (box.querySelector('.lc-all') || box.querySelectorAll('.product-color-card').length < 2) return;
      var label = box.querySelector('.product-color-options__label'); if (!label) return;
      var wrap = document.createElement('div'); wrap.className = 'lc-label-wrap';
      label.parentNode.insertBefore(wrap, label); wrap.appendChild(label);
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'lc-all'; btn.textContent = 'VIEW ALL'; btn.setAttribute('aria-haspopup', 'dialog');
      btn.addEventListener('click', function () { openLayer(box, btn); });
      wrap.appendChild(btn);
    });
  }

  function start() {
    try { buildPc(); } catch (e) { console.error('lumen nav', e); }
    try { buildMobile(); } catch (e) { console.error('lumen mobile nav', e); }
    try { buildList(); } catch (e) { console.error('lumen list', e); }
    try { buildColors(); } catch (e) { console.error('lumen colors', e); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
